export default __webpack_public_path__ + "img/18bcaac611b1fece48d7c5cd6d685854.svg";